import { render, staticRenderFns } from "./TutorialVideos.vue?vue&type=template&id=4445643a&scoped=true&"
import script from "./TutorialVideos.vue?vue&type=script&lang=js&"
export * from "./TutorialVideos.vue?vue&type=script&lang=js&"
import style0 from "./TutorialVideos.vue?vue&type=style&index=0&id=4445643a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4445643a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4445643a')) {
      api.createRecord('4445643a', component.options)
    } else {
      api.reload('4445643a', component.options)
    }
    module.hot.accept("./TutorialVideos.vue?vue&type=template&id=4445643a&scoped=true&", function () {
      api.rerender('4445643a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/TutorialVideos.vue"
export default component.exports